function createTheme(colorScheme) {
    const theme =  {
        '--app-hr': '#FFF',
        '--app-btn-bg': 'var(--cinema-primary-color, #FF6900)',
        '--app-btn-color': '#FFF',
        '--app-btn-border': 'var(--cinema-primary-color, #FF6900)',
        '--app-btn-hover-bg': 'transparent',
        '--app-btn-hover-color': 'var(--cinema-primary-color, #FF6900)',
        '--app-select-placeholder': 'rgb(100, 100, 100)',
        '--app-select-placeholder-disabled': 'rgb(128, 128, 128)',

        '--cinema-color': '#FFF',
        '--cinema-background': '#292F38',
        '--cinema-background-hover': '#292F38',
        '--cinema-border': '#393E47',
        '--cinema-address': '#868686',
        '--cinema-attr-separator': 'var(--cinema-primary-color, #FF6900)',
        '--cinema-concession-btn-border': 'var(--cinema-primary-color, #FF6900)',
        '--cinema-concession-btn-backgound': 'var(--cinema-primary-color, #FF6900)',
        '--cinema-concession-btn-backgound-hover': 'transparent',
        '--cinema-concession-btn-color': '#FFF',
        '--cinema-concession-btn-color-hover': 'var(--cinema-primary-color, #FF6900)',
        
        '--filters-color': '#000',
        '--filters-active-filters': 'var(--cinema-primary-color, #FF6900)',
        '--filters-selected-cinema': 'var(--cinema-primary-color, #FF6900)',
        '--filters-mobile-bg': '#141B25',
        '--filters-mobile-color': '#FFF',
        '--filters-mobile-content-bg': '#393E47',
        '--filters-mobile-item-border': '#000',
        '--filters-mobile-btn-all-bg': '#393e47',
        '--filters-mobile-btn-all-hover-bg': 'var(--cinema-primary-color, #FF6900)',
        '--filters-mobile-btn-all-hover-color': '#FFF',
        '--filters-mobile-btn-back-color': 'var(--cinema-primary-color, #FF6900)',
        '--filters-mobile-btn-close-color': 'var(--cinema-primary-color, #FF6900)',
        '--filters-mobile-attr-value': 'var(--cinema-primary-color, #FF6900)',
        '--filters-mobile-link-hover': 'var(--cinema-primary-color, #FF6900)',
        
        '--movie-color': '#FFF',
        '--movie-no-results-highlight': 'var(--cinema-primary-color, #ff6900)',
        
        '--movie-popup-header-border': '#5D5D5D',

        '--tab-color': '#858585',
        '--tab-active-color': '#FFFFFF',
        '--tab-active-border': 'var(--cinema-primary-color, #FF6900)',
        
        '--location-btn-current-bg': '#292F38',
        '--location-btn-current-color': '#FFF',
        '--location-btn-current-hover-bg': '#292F38',
        '--location-btn-current-hover-color': '#FFF',
        '--location-btn-current-hover-border': 'var(--cinema-primary-color, #FF6900)',
        '--location-btn-current-active-bg': '#0E1017',
        '--location-btn-current-active-color': 'var(--cinema-primary-color, #FF6900)',
        '--location-btn-current-active-border': 'var(--cinema-primary-color, #FF6900)',
        '--location-btn-current-active-hover-bg': 'transparent',
        '--location-label-color': '#868686',
        '--location-field-bg': '#292F38',
        '--location-field-color': '#FFF',
        '--location-value-color': '#FFF',
        '--location-value-border': 'var(--cinema-primary-color, #FF6900)',
        '--location-value-border-mobile': '#FFF',
    };

    if (colorScheme === 'light') {
        theme['--app-hr'] = '#C8C8C8';

        theme['--cinema-color'] = '#000';
        theme['--cinema-background'] = '#C8C8C8';
        theme['--cinema-background-hover'] = '#C8C8C8';
        theme['--cinema-border'] = '#C8C8C8';
        theme['--cinema-address'] = '#000';

        theme['--filters-mobile-bg'] = '#F6F6F6';
        theme['--filters-mobile-color'] = '#000';
        theme['--filters-mobile-content-bg'] = '#C8C8C8';

        theme['--movie-color'] = '#000';

        theme['--movie-popup-header-border'] = 'var(--cinema-primary-color, #FF6900)';

        theme['--tab-active-color'] = '#000';
        theme['--tab-active-border'] = 'var(--cinema-primary-color, #FF6900)';

        theme['--location-btn-current-bg'] = '#C8C8C8';
        theme['--location-btn-current-color'] = '#000';
        theme['--location-btn-current-active-bg'] = '#FFF';
        theme['--location-btn-current-hover-bg'] = '#FFF';
        theme['--location-btn-current-hover-color'] = '#000';
        theme['--location-field-bg'] = '#C8C8C8';
        theme['--location-field-color'] = '#000';
    }

    if (colorScheme === 'cinepolis') {
        theme['--app-hr'] = '#B2B2B2';

        theme['--cinema-color'] = '#002069';
        theme['--cinema-background'] = '#FFF';
        theme['--cinema-background-hover'] = '#B2B2B2';
        theme['--cinema-border'] = '#FFF';
        theme['--cinema-address'] = '#002069';
        theme['--cinema-attr-separator'] = '#002069';
        theme['--cinema-concession-btn-border'] = '#002069';
        theme['--cinema-concession-btn-backgound'] = '#002069';
        theme['--cinema-concession-btn-color-hover'] = '#002069';

        theme['--movie-color'] = '#002069';

        theme['--tab-active-color'] = '#002069';
        theme['--tab-active-border'] = '#002069';

        theme['--location-btn-current-bg'] = '#C8C8C8';
        theme['--location-btn-current-color'] = '#000';
        theme['--location-btn-current-active-bg'] = '#FFF';
        theme['--location-btn-current-hover-bg'] = '#FFF';
        theme['--location-btn-current-hover-color'] = '#000';
        theme['--location-field-bg'] = '#C8C8C8';
        theme['--location-field-color'] = '#000';
    }

    const themeContent = Object.entries(theme)
        .map((v) => `${v[0]}:${v[1]}`)
        .join(';');
    return `:root{${themeContent}}`;
}

function loadTheme(colorScheme) {
    const themeContent = createTheme(colorScheme);
    const themeStyle = document.getElementById('client-theme');
    document.body.setAttribute('theme', colorScheme);
    if (themeStyle) {
        themeStyle.textContent = themeContent;
    } else {
        const style = document.createElement('style');
        style.id = 'client-theme';
        style.textContent = themeContent;
        
        document.head.append(style);
        // document.head.appendChild(style);
    }
}

export default loadTheme;
